
import { Vue, Component } from "vue-property-decorator";
import { formatDateWithTime } from "../../../utils";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import { InventoryItemResource } from "@/models/api/barcodeSystem/inventory/inventoryItems";
const inventoryModuleState = getModule(InventoryModule);
const barcodeOrderModuleState = getModule(BarcodeOrderModule);

@Component({
  components: {
  }
})
export default class InventoryItem extends Vue {
  transLogsLoading: boolean = false;
  deleteLoading: boolean = false;

  get currentInventoryItem(): InventoryItemResource {
    return inventoryModuleState.currentInventoryItem;
  }

  get companyId(): number {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.companyId
      : null; 
  }

  set companyId(val: number){
    inventoryModuleState.setItemCompanyId(val)
  }

  get companyIds(): number[] {
    return inventoryModuleState.currentInventoryItem
      ?  [inventoryModuleState.currentInventoryItem.companyId]
      : null;
  }

  get manufacturerCode(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.manufacturerCode
      : null; 
  }

  set manufacturerCode(val: string){
    inventoryModuleState.setItemManufacturerCode(val)
  }

  get itemType(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.itemType
      : null; 
  }

  set itemType(val: string){
    inventoryModuleState.setItemType(val)
  }

  get poNumber(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.poNumber
      : null; 
  }

  set poNumber(val: string){
    inventoryModuleState.setItemPoNumber(val)
  }

  get modelNumber(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.modelNumber
      : null; 
  }

  set modelNumber(val: string){
    inventoryModuleState.setItemModelNumber(val)
  }

  get sku(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.sku
      : null; 
  }

  set sku(val: string){
    inventoryModuleState.setItemSku(val)
  }

  get serialNumber(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.serialNumber
      : null; 
  }

  set serialNumber(val: string){
    inventoryModuleState.setItemSerialNumber(val)
  }

  get itemDescription(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.itemDescription
      : null; 
  }

  set itemDescription(val: string){
    inventoryModuleState.setItemDescription(val)
  }

  get quantity(): number {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.quantity
      : null; 
  }

  set quantity(val: number){
    inventoryModuleState.setItemQuantity(val)
  }

  get isDamaged(): boolean {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.isDamaged
      : null; 
  }

  set isDamaged(val: boolean){
    inventoryModuleState.setItemDamaged(val)
  }

  get damageCode(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.damageCode
      : null; 
  }

  set damageCode(val: string){
    inventoryModuleState.setItemDamageCode(val)
  }

  get returned(): boolean {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.returned
      : null; 
  }

  set returned(val: boolean){
    inventoryModuleState.setItemReturned(val)
  }

  get returnReason(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.returnReason
      : null; 
  }

  set returnReason(val: string){
    inventoryModuleState.setItemReturnReason(val)
  }

  get returnComment(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.returnComment
      : null; 
  }

  set returnComment(val: string){
    inventoryModuleState.setItemReturnComment(val)
  }

  get raNumber(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.raNumber
      : null; 
  }

  set raNumber(val: string){
    inventoryModuleState.setItemRaNumber(val)
  }

  get auctionNumber(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.auctionNumber
      : null; 
  }

  set auctionNumber(val: string){
    inventoryModuleState.setItemAuctionNumber(val)
  }

  get disposalNumber(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.disposalNumber
      : null; 
  }

  set disposalNumber(val: string){
    inventoryModuleState.setItemDisposalNumber(val)
  }  
  
  get shrinkage(): boolean {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.shrinkage
      : null; 
  }

  set shrinkage(val: boolean){
    inventoryModuleState.setItemShrinkage(val)
  }

  get cubes(): number {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.cubes
      : 0; 
  }

  set cubes(val: number){
  } 

  get itemScan(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.itemScan
      : ""; 
  }

  set itemScan(val: string){
  } 

  get palletId(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.palletId
      : ""; 
  }

  set palletId(val: string){
  } 

  get warehouseLocationCode(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.warehouseLocationCode
      : ""; 
  }

  set warehouseLocationCode(val: string){
  } 

  get orderNumber(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.orderNumber
      : ""; 
  }

  set orderNumber(val: string){
  }    
  
  get orderId(): number {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.orderId
      : null; 
  }

  set orderId(val: number){
  }  


  get crn(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.crn
      : ""; 
  }

  set crn(val: string) {

  }
  
  

  get status(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.status
      : ""; 
  }

  set status(val: string){
  }

  get statusDescription(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.statusDescription
      : ""; 
  }

  set statusDescription(val: string){
  }

  get facilityCode(): string {
    return inventoryModuleState.currentInventoryItem
      ? inventoryModuleState.currentInventoryItem.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }


  get receivedDateTimeFormatted(): string{
    return inventoryModuleState.currentInventoryItem
      ? formatDateWithTime(inventoryModuleState.currentInventoryItem.receivedDate)
      : "";
  }

  set receivedDateTimeFormatted(val: string){
  }

  get loadedDateTimeFormatted(): string{
    return inventoryModuleState.currentInventoryItem
      ? formatDateWithTime(inventoryModuleState.currentInventoryItem.loadedDate)
      : "";
  }

  set loadedDateTimeFormatted(val: string){
  }

  get deliveredDateTimeFormatted(): string{
    return inventoryModuleState.currentInventoryItem
      ? formatDateWithTime(inventoryModuleState.currentInventoryItem.deliveredDate)
      : "";
  }
  
  set deliveredDateTimeFormatted(val: string){
  }

  viewPallet() {
    inventoryModuleState.viewPalletShortcutAction({selectedItems: [{id: this.palletId}]})
  }
  viewOrder() {
    barcodeOrderModuleState.viewBarcodeOrderShortcutAction({selectedItems: [{id: this.orderId}]})
  }
}
